export const THEME_STORAGE_KEYS = {
  public: 'publicDarkMode',
  app: 'appDarkMode'
} as const;

export const PUBLIC_THEME_ROUTES = new Set([
  '/',
  '/login',
  '/verify-email',
  '/privacy',
  '/terms',
  '/cookies',
  '/contact',
  '/about'
]);
